<loading-spinner></loading-spinner>

<router-outlet (window:resize)="onResize($event)"></router-outlet>